/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandDatabricks = createReactComponent("outline", "brand-databricks", "IconBrandDatabricks", [["path", { "d": "M3 17l9 5l9 -5v-3l-9 5l-9 -5v-3l9 5l9 -5v-3l-9 5l-9 -5l9 -5l5.418 3.01", "key": "svg-0" }]]);

export { IconBrandDatabricks as default };
//# sourceMappingURL=IconBrandDatabricks.mjs.map
